import { motion } from 'framer-motion';
import React, { Fragment } from 'react';
import { Asset } from '../../../queries/ats/titles/types/asset';
import { Source } from '../../../queries/ats/titles/types/sources';
import { MoreEpisodesButton } from '../details-button/more-episodes-button';
import { buttonProps } from './secondary-buttons-variants';

interface ThirdPartySecondaryButtonsRowProps {
  asset: Asset;
  source: Source;
}

const MotionMoreEpisodesButton = motion(MoreEpisodesButton);

export function ThirdPartySecondaryButtonsRow({ asset, source }: ThirdPartySecondaryButtonsRowProps) {
  return (
    <Fragment>
      {asset.type === 'episode' ? (
        <MotionMoreEpisodesButton {...buttonProps('more-episodes')} asset={asset} source={source} />
      ) : null}
    </Fragment>
  );
}
